import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 40 40",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			fill: "#000",
			fillRule: "evenodd",
			clipRule: "evenodd",
			children: [/* @__PURE__ */ _jsx("path", { d: "M33.81 9.09h5.238v29.698H.952V1.212h31.43v6.06c0 1.005.639 1.82 1.428 1.82Zm-.477-7.878h.104l5.61 6.591v.076H33.81c-.264 0-.477-.272-.477-.606v-6.06ZM.953 40h38.095c.526 0 .952-.543.952-1.212V7.803c0-.338-.111-.66-.306-.89L34.084.32C33.906.115 33.68 0 33.44 0H.948C.422 0 0 .543 0 1.212v37.576C0 39.458.426 40 .952 40Z" }), /* @__PURE__ */ _jsx("path", { d: "M8 17.5c0-.276.244-.5.545-.5h22.91c.3 0 .545.224.545.5s-.244.5-.545.5H8.545c-.3 0-.545-.224-.545-.5Zm0 7c0-.276.244-.5.545-.5h22.91c.3 0 .545.224.545.5s-.244.5-.545.5H8.545c-.3 0-.545-.224-.545-.5Z" })]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "a",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M0 0h40v40H0z",
				fill: "#fff"
			})
		}) })
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2040%2040%22%3E%3Cg%20fill%3D%22%23000%22%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%3E%3Cpath%20d%3D%22M33.81%209.09h5.238v29.698H.952V1.212h31.43v6.06c0%201.005.639%201.82%201.428%201.82Zm-.477-7.878h.104l5.61%206.591v.076H33.81c-.264%200-.477-.272-.477-.606v-6.06ZM.953%2040h38.095c.526%200%20.952-.543.952-1.212V7.803c0-.338-.111-.66-.306-.89L34.084.32C33.906.115%2033.68%200%2033.44%200H.948C.422%200%200%20.543%200%201.212v37.576C0%2039.458.426%2040%20.952%2040Z%22%2F%3E%3Cpath%20d%3D%22M8%2017.5c0-.276.244-.5.545-.5h22.91c.3%200%20.545.224.545.5s-.244.5-.545.5H8.545c-.3%200-.545-.224-.545-.5Zm0%207c0-.276.244-.5.545-.5h22.91c.3%200%20.545.224.545.5s-.244.5-.545.5H8.545c-.3%200-.545-.224-.545-.5Z%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22a%22%3E%3Cpath%20d%3D%22M0%200h40v40H0z%22%20fill%3D%22%23fff%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E%0A";
